import {AboutPageProps, MetaTagsProps} from "@/types";
import {OG_PATH, WEBSITE_URL, BUSINESS_NAME} from "@/content";

export const metaTagsAbout : MetaTagsProps = {
    title: `${BUSINESS_NAME} - About Us`,
    description: `${BUSINESS_NAME} - Proelec Group is a trusted provider of electrical services in Sydney, offering expert solutions for residential and commercial needs.`,
    keywords: "proelec group, level 2 electrician sydney, electrical services sydney, residential electrician sydney, commercial electrician sydney, data cabling sydney, switchboard upgrades sydney, lighting installations sydney, electrical repairs sydney, licensed electricians sydney",
    url: `${WEBSITE_URL}/about`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const aboutPageContent : AboutPageProps = {
    title: 'About Us | Proelec Group Electrical Services',
    description: 'Learn more about our company, our mission, and the team behind our success.',
    images: [],
}
